export const lineHeightConfigModel = {
    options: [
        'default',
        1,
        1.5,
        2,
        2.5,
        3
    ]
};
